import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { DeliveryStoresStatusCSVGenerationJobService } from '@/services/StoreManagement/DeliveryStoresStatusCSVGenerationJob/DeliveryStoresStatusCSVGenerationJobService';

export type DeliveryStoresStatusCSVGenerationJobGetPresignedURLResponse = {
  presigned_url: string;
};

export const useDeliveryStoresStatusCSVGenerationJobGetPresignedURL = async (
  id: string
): Promise<DeliveryStoresStatusCSVGenerationJobGetPresignedURLResponse> => {
  const deliveryStoresStatusCSVGenerationJobService =
    new DeliveryStoresStatusCSVGenerationJobService(getClient());
  try {
    const res =
      await deliveryStoresStatusCSVGenerationJobService.getPresignedURL(id);
    return res;
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
